
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/iframe/[uuid]",
      function () {
        return require("private-next-pages/iframe/[uuid]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/iframe/[uuid]"])
      });
    }
  